<template>
  <section class="worth">
    <div class="container">
      <a-typography-title :level="1">
        成本优化常见难题
      </a-typography-title>
      <a-row :gutter="[20,20]">
        <a-col v-for="item in expand.content"
               :xs="24" :md="12" :xl="6">
          <div class="item">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              <p v-for="v in item.text">
                {{ v }}
              </p>
            </a-typography-paragraph>
          </div>
        </a-col>
      </a-row>
      <!--<a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">-->
      <!--    <a-button type="link" class="button_1"-->
      <!--              @click="$Store.Page().openModal('modalOperate','reserve');">-->
      <!--        预约演示-->
      <!--    </a-button>-->
      <!--</a-space>-->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_worth',
  data(): DataInterface {
    return {
      expand: {
        content: [
          {
            title: '账单管理难',
            text: [
              '账号数量多，费用统计复杂',
              '难以统一管理多个云平台的费用',
              '对账操作复杂、时间成本高'
            ]
          },
          {
            title: '成本分摊难',
            text: [
              '难以将总成本精确拆分到应用',
              '无法按应用拆分K8s集群成本'
            ]
          },
          {
            title: '成本优化难',
            text: [
              '难以清晰统计资源浪费情况',
              '缺少系统性的成本优化方案',
              '缺少具体优化措施的实施能力'
            ]
          },
          {
            title: '持续运营难',
            text: [
              '业务资源消耗不受限，容易浪费',
              '成本难预测，难以合理分配资源',
              '难以根据定期报告持续掌控成本'
            ]
          }
        ]
      }
    };
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/productCostPilot/';

.worth {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background-color: @color_9;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  position: relative;
  margin: 0;
  .font(center, @title, @color_12, @title, true);
  
  &::before {
    content: '';
    display: block;
    .position(bottom, -15px);
    width: 72px;
    height: 3px;
    margin: 0 auto;
    background-color: @color_6;
  }
}

.ant-row {
  margin: @margin 0 0;
  
  .ant-col {
    &:nth-child(1) {
      .item::before {
        .bg('@{image}icon_1_1.png', 186px, 192px);
      }
    }
    
    &:nth-child(2) {
      .item::before {
        .bg('@{image}icon_1_2.png', 161px, 178px);
      }
    }
    
    &:nth-child(3) {
      .item::before {
        .bg('@{image}icon_1_3.png', 197px, 180px);
      }
    }
    
    &:nth-child(4) {
      .item::before {
        .bg('@{image}icon_1_4.png', 156px, 180px);
      }
    }
  }
}


.item {
  @time: 1s;
  @style: transform @time, box-shadow @time;
  position: relative;
  width: 100%;
  max-width: 295px;
  height: 350px;
  padding: 0 10px 10px;
  margin: 0 auto;
  .shadow(0 0 10px fade(@color_black, 0));
  .transition(@style);
  
  &:hover {
    .shadow(0 0 10px fade(@color_black, 10));
    .transform(scale(1.02));
  }
  
  &::before {
    content: '';
    display: block;
    width: 200px;
    max-width: 100%;
    height: 200px;
    margin: 0 auto;
    background-position: center !important;
  }
  
  h5.ant-typography {
    margin: 20px 0 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    margin: 20px 0 0;
    
    p {
      position: relative;
      padding-left: 20px;
      margin: 0;
      .font(justify, @text+@line, @color_3, @text);
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 11px, auto, auto, 0);
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: @color_6;
      }
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .worth {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
    
    &::before {
      display: none;
    }
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
    
    .ant-col {
      @scale: 0.7;
      
      &:nth-child(1) {
        .item::before {
          .bg('@{image}icon_1_1.png', 186px*@scale, 192px*@scale);
        }
      }
      
      &:nth-child(2) {
        .item::before {
          .bg('@{image}icon_1_2.png', 161px*@scale, 178px*@scale);
        }
      }
      
      &:nth-child(3) {
        .item::before {
          .bg('@{image}icon_1_3.png', 197px*@scale, 180px*@scale);
        }
      }
      
      &:nth-child(4) {
        .item::before {
          .bg('@{image}icon_1_4.png', 156px*@scale, 180px*@scale);
        }
      }
    }
  }
  
  .item {
    height: auto;
    
    &::before {
      height: 150px;
      .transform(scale(0.9));
    }
    
    h5.ant-typography {
      margin: @margin_mo 0 0;
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      margin: @margin_mo 0 0;
      .font(justify, @text_mo, @color_3, @text_mo);
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>